import React from 'react';
import { AuthProvider } from 'react-oauth2-code-pkce';

export const AuthWrapperProvider = ({ auth0Config, children }) => {
  const { auth0Domain, auth0ClientId, logOut } = auth0Config;
  const authConfig = {
    clientId: auth0ClientId,
    authorizationEndpoint: `${auth0Domain}/as/authorization.oauth2`,
    tokenEndpoint: `${auth0Domain}/as/token.oauth2`,
    redirectUri: window.location.origin,
    logoutEndpoint: `${auth0Domain}/idp/startSLO.ping`,
    logoutRedirect: window.location.origin,
    // extraLogoutParameters: {
    //   "TargetResource": window.location.origin,
    // },
    scope: 'openid profile email communities',
    tokenExpiresIn: 3_000,
    onRefreshTokenExpire: (event) => {
      if (event && typeof event.logIn === 'function') {
        event.logIn(undefined, undefined, 'redirect');
      } else {
        logOut();
        window.location.href = window.location.origin;
      }
    },
  };

  return <AuthProvider authConfig={authConfig}>{children}</AuthProvider>;
};